import styles from './icon.module.css';
import { ReactComponent as BirthdayTreat } from '../../assets/icons/birthdayTreat.svg';
import { ReactComponent as Cross } from '../../assets/icons/closeIcon.svg';
import { ReactComponent as EarlyAccessSales } from '../../assets/icons/earlyAccessSales.svg';
import { ReactComponent as EarlyAccessCollections } from '../../assets/icons/earlyAccessCollections.svg';
import { ReactComponent as ExclusiveAccessCollections } from '../../assets/icons/exclusiveAccessCollections.svg';
import { ReactComponent as ExclusiveMemberDiscounts } from '../../assets/icons/exclusiveMemberDiscounts.svg';
import { ReactComponent as FreeShipping } from '../../assets/icons/freeShipping.svg';
import { ReactComponent as GreenShipping } from '../../assets/icons/greenShipping.svg';
import { ReactComponent as MembersWeek } from '../../assets/icons/membersWeek.svg';
import { ReactComponent as UpcyclingTutorials } from '../../assets/icons/upcyclingTutorials.svg';
import { ReactComponent as WelcomeOffer } from '../../assets/icons/welcomeOffer.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/icon-arrow-left.svg';
import { ReactComponent as Info } from '../../assets/icons/icon-info.svg';
import { useRef, useEffect } from 'react';

const RawIcons = {
  birthdayTreat: <BirthdayTreat />,
  cross: <Cross />,
  earlyAccessSales: <EarlyAccessSales />,
  earlyAccessCollections: <EarlyAccessCollections />,
  exclusiveAccessCollections: <ExclusiveAccessCollections />,
  exclusiveMemberDiscounts: <ExclusiveMemberDiscounts />,
  freeShipping: <FreeShipping />,
  greenShipping: <GreenShipping />,
  membersWeek: <MembersWeek />,
  // Reuse icon from members week. Name is different for testing.
  exclusiveEvents: <MembersWeek />,
  upcyclingTutorials: <UpcyclingTutorials />,
  welcomeOffer: <WelcomeOffer />,
  arrowLeft: <ArrowLeft />,
  info: <Info />,
};

export type IconName = keyof typeof RawIcons;

export interface IconProps {
  size?: 'small' | 'medium' | 'large' | number;
  onClick?: () => void;
  name: IconName;
}

const Icon = ({ size = 'medium', ...props }: IconProps) => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const sizing =
    typeof size === 'string' ? styles[`icon--${size}`] : styles[`icon--custom`];

  // Setting custom CSS property only within this specific DOM element.
  // This way we can provide any custom size to icon.
  useEffect(() => {
    if (typeof size === 'number' && divRef.current) {
      divRef.current.style.setProperty(
        '--crmis-dynamic-icon-size',
        `${size}px`
      );
    }
  }, [size]);

  return (
    <span
      ref={divRef}
      className={[styles.icon, sizing].join(' ')}
      onClick={props.onClick}
    >
      {RawIcons[props.name]}
    </span>
  );
};

export default Icon;
